import { render, staticRenderFns } from "./TermsOfUsePage.vue?vue&type=template&id=c23588d8"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUsePage.vue?vue&type=style&index=0&id=c23588d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports